$(document).ready(function() {

setTimeout(function(){
  var regex = /^[a-zA-Z0-9 .'-]+$/;
  var inputToCheck = $(".alphanumericOnly input[type='text']");


  console.log(inputToCheck);
  inputToCheck.keyup(function(){
  if(!regex.test(inputToCheck.val())) {
    $("button.add-cart").prop("disabled",true);
    $(".alphanumericOnly input").css({"border": "1px solid red", "outline":"red"});
    if($(".alphanumericOnly span .alert").length == 0){
        $(".alphanumericOnly span").append("<span class='alert alert-danger'>Accepted characters: A-Z, 0-9, spaces, apostrophes, dash and periods.</span>");
    }
  }else{
    $("button.add-cart").prop("disabled",false);
    if($( ".alphanumericOnly span .alert").length){
      $( ".alphanumericOnly span .alert").remove();
    }
  }
});
    },1000);


});
